








import { defineComponent, computed, watch, ref } from '@vue/composition-api';
import { getStore } from './store';
import { useRouter } from './router';
import { useClientChecker } from './client-checker';
/* import SnackbarPopup from './components/modal/SnackbarPopup.vue'; */

export default defineComponent({
    /* components: { SnackbarPopup }, */

    setup(context) {
        const wrapperScrollable = ref(true);

        const { router, route } = useRouter();

        const store = getStore();

        const client = useClientChecker();

        const pageTransition = ref('');

        /* watch(route, (newRoute, oldRoute) => {            
            if (!newRoute || !oldRoute) { 
                return; 
            }

            if (newRoute.meta.treeLevel < oldRoute.meta.treeLevel) {
                pageTransition.value = 'page-slide-right';
            }
            else {
                pageTransition.value = 'page-slide-left';
            }
        }); */

        const onStartTransition = () => {
            wrapperScrollable.value = false;
        };

        const onEndTransition = () => {
            wrapperScrollable.value = true;
        }

        const identityClasses = computed(() => {
            if (client.clientIsToolbox.value) {
                return 'identity--toolbox';
            }
            else if (client.clientIsYesly.value) {
                return 'identity--yesly';
            }
            else if (client.clientIsGoogleYesly.value) {
                return 'identity--yesly identity--yesly-google';
            }
            else if (client.clientIsAlexaYesly.value) {
                return 'identity--yesly identity--alexa-google';
            }
            else if (client.clientIsBliss2.value) {
                return 'identity--bliss';
            }
            else if (client.clientIsBliss.value) {
                return 'identity--bliss identity--bliss-legacy';
            }
            else if (client.clientIsGoogleBliss.value) {
                return 'identity--bliss identity--bliss-google';
            }
            else if (client.clientIsAlexaBliss.value) {
                return 'identity--bliss identity--bliss-alexa';
            }
            else {
                return null;
            }
        });

        const themeClasses = computed(() => {
            if (store.state.theme) {
                return `theme--${store.state.theme}`;
            }
            return null;
        });

        const wrapperClasses = computed(() => {
            return {
                'antialiased text-text-01': true,
                'overflow-hidden': !wrapperScrollable.value
            };
        });

        return {
            pageTransition,
            wrapperClasses,
            identityClasses,
            themeClasses,
            onStartTransition,
            onEndTransition
        };
    }
});
